<template>
    <div class="item-type goodbad-wrapper">
        <image-editor v-if="dataStore.activeType == 'image'"></image-editor>
        <map-editor v-if="dataStore.activeType == 'map'"></map-editor>
    </div>
</template>

<script>

import dataStore from "../../store";
import globalFunctions from "../../globalFunctions";
import MapEditor from './../item-type/MapEditor';
import ImageEditor from './../item-type/ImageEditor';
import { Fragment } from 'vue-fragment'

export default {

    components: {
        MapEditor,
        ImageEditor,
        Fragment
    },
    data() {
        return {
            dataStore,
            globalFunctions,
        }
    },

};
</script>
